import { DRQFilterInput } from "@/utils/drq";

// Interface pour les conditions DRQ dans l'UI
export interface DRQConditionUI {
  id: string;
  field_name: string;
  operator: string;
  value: string;
  type?: "text" | "select" | "checkbox" | "combobox" | "date-range" | "datetime-range";
}

export interface DRQGroupUI {
  id: string;
  conditions: DRQConditionUI[];
  operator: 'and' | 'or';
}

// Opérateurs disponibles par type de champ
export const OPERATORS_BY_TYPE = {
  text: [
    { value: "equals", label: "Égal à" },
    { value: "not_equal_to", label: "Différent de" },
    { value: "contains", label: "Contient" },
    { value: "not_contains", label: "Ne contient pas" },
    { value: "starts_with", label: "Commence par" },
    { value: "ends_with", label: "Termine par" },
    { value: "is_empty", label: "Est vide" },
    { value: "is_not_empty", label: "N'est pas vide" },
  ],
  select: [
    { value: "equals", label: "Égal à" },
    { value: "not_equal_to", label: "Différent de" },
    { value: "is_empty", label: "Est vide" },
    { value: "is_not_empty", label: "N'est pas vide" },
  ],
  checkbox: [
    { value: "equals", label: "Égal à" },
    { value: "not_equal_to", label: "Différent de" },
  ],
  combobox: [
    { value: "equals", label: "Égal à" },
    { value: "not_equal_to", label: "Différent de" },
    { value: "contains", label: "Contient" },
    { value: "not_contains", label: "Ne contient pas" },
  ],
  "date-range": [
    { value: "equals", label: "Égal à" },
    { value: "not_equal_to", label: "Différent de" },
    { value: "gt", label: "Après" },
    { value: "gte", label: "Après ou égal à" },
    { value: "lt", label: "Avant" },
    { value: "lte", label: "Avant ou égal à" },
    { value: "is_empty", label: "Est vide" },
    { value: "is_not_empty", label: "N'est pas vide" },
  ],
  "datetime-range": [
    { value: "equals", label: "Égal à" },
    { value: "not_equal_to", label: "Différent de" },
    { value: "gt", label: "Après" },
    { value: "gte", label: "Après ou égal à" },
    { value: "lt", label: "Avant" },
    { value: "lte", label: "Avant ou égal à" },
    { value: "is_empty", label: "Est vide" },
    { value: "is_not_empty", label: "N'est pas vide" },
  ],
} as const;

// Conversion entre DRQConditionUI et DRQFilterInput
export const convertToDRQFilterInput = (condition: DRQConditionUI): DRQFilterInput => ({
  field_name: condition.field_name,
  operator: condition.operator,
  value: condition.value,
  type: condition.type,
});

export const convertFromDRQFilterInput = (filterInput: DRQFilterInput): DRQConditionUI => ({
  id: `${filterInput.field_name}_${Date.now()}_${Math.random()}`,
  field_name: filterInput.field_name,
  operator: filterInput.operator,
  value: filterInput.value,
  type: filterInput.type,
}); 